import { Div, ModalWindow, Span } from '@tblabs/truffle';
import { DefaultButton } from '../../General/Buttons/DefaultButton';
import { Icon } from './../../General/Icon';
import { Translations } from '../../../Translations/Translations';
import { DangerButton } from '../../General/Buttons/DangerButton';
import { SnapStorage } from '../../../Services/Storage/SnapStorage';


export class MemoryCleanupWindow extends ModalWindow
{
    constructor(_storage: SnapStorage, _lang: Translations, showWarning: boolean = false)
    {
        super(showWarning ? _lang.MemoryExhaust : _lang.MemoryCleanup, true, false, true);

        this.content.TextAlignCenter()

        const count = _storage.Items.Count;
        const totalSizeInBytes = _storage.Items.Items.reduce((sum, item) => sum + item.Item.Picture.Image.size, 0);
        const totalSizeInKB = (totalSizeInBytes / 1024).toFixed(1);
        this.AddContent(

            new Div()
                .Visible(showWarning)
                .Append(_lang.BrowserMemoryExhaustWarning)
                .FullWidth()
                .Style("margin-bottom: 16px"),

            new DangerButton(_lang.RemoveAllSnaps + " (" + count + ")", () =>
            {
                _storage.RemoveAll();
                this.CloseWindow();
            }).FullWidth(),

            new DangerButton(_lang.RemoveSelected + " (" + _storage.Items.Filter(item => item.Item.IsSelectedByUser.value).length + ")", () =>
            {
                _storage.RemoveSelected();
                this.CloseWindow();
            }).FullWidth().MarginTop(8),

            new DangerButton(_lang.RemoveUnselected + " (" + _storage.Items.Filter(item => !item.Item.IsSelectedByUser.value).length + ")", () =>
            {
                _storage.RemoveUnselected();
                this.CloseWindow();
            }).FullWidth().MarginTop(8),
        );

        this.AddToFooter(
            new Icon("memory", "#666").Style("transform: translate(-2px, 8px); float: left;  margin-left: 8px;"),
            new Span(`${count} photos, ${totalSizeInKB} kb`).FloatLeft().MarginTop(8),
            new DefaultButton(_lang.Cancel, () => this.CloseWindow())
        );

        this.OpenWindow();
    }
}
